import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Plane, User, LogOut, LogIn } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useAgentAuth } from '../context/AgentAuthContext';
import AgentBalanceBadge from './agent/AgentBalanceBadge';
import MobileOTPLogin from './MobileOTPLogin';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAuthenticated, logout } = useAuth();
  const { agent, isAuthenticated: isAgentAuthenticated, logout: agentLogout } = useAgentAuth();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const isAgentPortalRoute = location.pathname.startsWith('/agent');

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const handleAgentLogout = () => {
    agentLogout();
    navigate('/agent/login');
  };

  return (
    <>
      <nav className="bg-gradient-to-r from-[#335E77] via-[#345266] to-[#1B375B] text-white sticky top-0 z-50 shadow-lg hidden md:block">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center group" aria-label="ACF Tourism — Home">
              <img 
                src="/acf-tourism-logo.png" 
                alt="ACF Tourism BETA" 
                className="h-9 sm:h-10 w-auto max-w-[200px] object-contain transition-transform group-hover:scale-105"
                width="200"
                height="44"
              />
            </Link>

            {/* User Menu or Login */}
            {isAgentAuthenticated && agent ? (
              // Agent logged in
              <div className="flex items-center gap-4">
                {!isAgentPortalRoute && (
                  <AgentBalanceBadge
                    agent={agent}
                    variant="compact"
                    className="[&>div]:bg-teal-500/90 [&>div]:hover:bg-teal-500 [&>div]:transition-all [&>div]:duration-300"
                  />
                )}
                <Link 
                  to="/agent/dashboard"
                  className="flex items-center gap-2 px-4 py-2 rounded-md bg-white/10 hover:bg-white/20 transition-all duration-300"
                >
                  <User className="w-5 h-5" />
                  <div className="flex flex-col items-start">
                    <span className="text-xs text-white/70">Agent</span>
                    <span className="text-sm font-semibold">{agent.agency_name || agent.full_name}</span>
                  </div>
                </Link>
                <button
                  onClick={handleAgentLogout}
                  className="flex items-center gap-2 px-4 py-2 rounded-md border-2 border-white/50 hover:bg-white hover:text-[#1B375B] transition-all duration-300 text-sm font-semibold"
                >
                  <LogOut className="w-4 h-4" />
                  Logout
                </button>
              </div>
            ) : isAuthenticated && user ? (
              // B2C User logged in
              <div className="flex items-center gap-4">
                <Link
                  to="/my-tickets"
                  className="text-sm font-semibold text-white/90 hover:text-white"
                >
                  Help &amp; Tickets
                </Link>
                <Link 
                  to="/user/dashboard/profile"
                  className="flex items-center gap-2 px-4 py-2 rounded-md bg-white/10 hover:bg-white/20 transition-all duration-300"
                >
                  <User className="w-5 h-5" />
                  <span className="text-sm font-semibold">{user.full_name}</span>
                </Link>
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-2 px-4 py-2 rounded-md border-2 border-white/50 hover:bg-white hover:text-[#1B375B] transition-all duration-300 text-sm font-semibold"
                >
                  <LogOut className="w-4 h-4" />
                  Logout
                </button>
              </div>
            ) : (
              // Not logged in
              <button
                onClick={() => setShowLoginModal(true)}
                className="flex items-center gap-2 px-5 py-2 rounded-md border-2 border-white text-white hover:bg-white hover:text-[#1B375B] transition-all duration-300 text-sm font-semibold"
              >
                <LogIn className="w-4 h-4" />
                LOGIN / SIGNUP
              </button>
            )}
          </div>
        </div>
      </nav>

      {/* Mobile OTP Login Modal */}
      <MobileOTPLogin 
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        onSuccess={(userData) => {
          console.log('Login successful:', userData);
          setShowLoginModal(false);
        }}
      />
    </>
  );
};

export default Navbar;
